import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "stepPanel",
    "stepIndicator",
    "prevButton",
    "nextButton",
    "completeActions",
    "stepCounter",
  ]

  static values = {
    currentStep: { type: Number, default: 1 },
  }

  connect() {
    this.showStep(this.currentStepValue)
  }

  next(event) {
    event.preventDefault()

    if (this.currentStepValue < this.stepPanelTargets.length) {
      this.currentStepValue++
      this.showStep(this.currentStepValue)
    }
  }

  previous(event) {
    event.preventDefault()

    if (this.currentStepValue > 1) {
      this.currentStepValue--
      this.showStep(this.currentStepValue)
    }
  }

  showStep(step) {
    this.stepPanelTargets.forEach((panel, index) => {
      panel.classList.toggle("hidden", index + 1 !== step)
    })

    this.stepIndicatorTargets.forEach((indicator, index) => {
      indicator.classList.toggle("step-primary", index + 1 <= step)
    })

    if (this.hasPrevButtonTarget) {
      this.prevButtonTarget.classList.toggle("hidden", step === 1)
    }

    if (this.hasNextButtonTarget) {
      this.nextButtonTarget.classList.toggle("hidden", step === this.stepPanelTargets.length)
    }

    if (this.hasCompleteActionsTarget) {
      this.completeActionsTarget.classList.toggle(
        "hidden",
        step !== this.stepPanelTargets.length,
      )
    }

    if (this.hasStepCounterTarget) {
      this.stepCounterTarget.textContent = `Paso ${step} de ${this.stepPanelTargets.length}`
    }
  }
}
